// extracted by mini-css-extract-plugin
export var quantityInput = "_h4-0";